import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'
import { firewallsService } from './services/firewalls-service'
import { logProfileService } from './services/log-profile-service'
import { subscriptionsService } from './services/subscriptions-service'
import { supportService } from './services/support-service'
import { scmBillingAssociationService } from './services/scm-billing-association-service'
import { validateScmCodeService } from './services/validate-scm-code-service'
import { regionsService } from './services/regions-service'
import { userRolesService } from './services/user-roles-service'
import { rulesService } from './services/rules-service'
import { accountsService } from './services/accounts-service'
import { policiesService } from './services/policies-service'
import { settingsService } from './services/settings-service'
import { tokensService } from './services/tokens-service'
import { userFederationsService } from './services/user-federation-service'
import { networkmonitoringService } from './services/networkmonitoring-service'
import { cloudmanagerService } from './services/cloudmanager-service'
import { tenantService } from './services/tenant-service'
import * as ReduxReducers from './slices';
import * as ReduxActions from './actions';
import ReduxResources from './utils/enums';

// Internal actions
import {setCspEnable, setPubSubMessageStatus} from "./slices/support";


const createRootReducer = (history: History) => combineReducers({
    router: connectRouter(history),
    ruleStacks: ReduxReducers.ruleStacks,
    firewalls: ReduxReducers.firewalls,
    users: ReduxReducers.users,
    support: ReduxReducers.support,
    [firewallsService.reducerPath]: firewallsService.reducer,
    [regionsService.reducerPath]: regionsService.reducer,
    [userRolesService.reducerPath]: userRolesService.reducer,
    [rulesService.reducerPath]: rulesService.reducer,
    [accountsService.reducerPath]: accountsService.reducer,
    [logProfileService.reducerPath]: logProfileService.reducer,
    [policiesService.reducerPath]: policiesService.reducer,
    [settingsService.reducerPath]: settingsService.reducer,
    [subscriptionsService.reducerPath]: subscriptionsService.reducer,
    [supportService.reducerPath]: supportService.reducer,
    [scmBillingAssociationService.reducerPath]: scmBillingAssociationService.reducer,
    [validateScmCodeService.reducerPath]: validateScmCodeService.reducer,
    [tokensService.reducerPath]: tokensService.reducer,
    [userFederationsService.reducerPath]: userFederationsService.reducer,
    [networkmonitoringService.reducerPath]: networkmonitoringService.reducer,
    [cloudmanagerService.reducerPath]: cloudmanagerService.reducer,
    [tenantService.reducerPath]: tenantService.reducer,
    // Add other reducers here
})

const ReduxActionsWithInternalAction = {
      ...ReduxActions,
      setCspEnable,
      setPubSubMessageStatus
}

export {
      createRootReducer,
      ReduxResources,
      ReduxActionsWithInternalAction as ReduxActions,
      ReduxReducers
};
